import tracking from "../../../../../../common/ts/core/tracking";
import {EventBus} from "../../../../../../common/ts/events/EventBus";
import dom from "../../../../../../common/ts/core/dom";
import {SaveEmailAlertRequestedEvent} from "../main/events";
import {FullPageModalCloseEvent} from "../../../../../../common/ts/events/Events";
import {
    ALERT_CREATION_SECTION_ADPAGE_BOX,
    ALERT_CREATION_SECTION_ADWORDS_MOBILE_BOTTOM,
    ALERT_CREATION_SECTION_MOBILE_BOTTOM,
    ALERT_CREATION_SECTION_ONPAGE_SEARCH_BOTTOM,
    ALERT_CREATION_SECTION_ONPAGE_SEARCH_BOTTOM_STEP_2,
    ALERT_CREATION_SECTION_ONPAGE_SEARCH_CTA_POP_UP_STEP_2,
    ALERT_CREATION_SECTION_ONPAGE_SEARCH_CTA_POP_UP_STEP_3,
    ALERT_CREATION_SECTION_ONPAGE_SEARCH_PAGINATION_POPUP,
    ALERT_CREATION_SECTION_ONPAGE_SEARCH_PAGINATION_POPUP_STEP_2,
    ALERT_CREATION_SECTION_PAID_CTA_POP_UP_STEP_2,
    ALERT_CREATION_SECTION_PAID_CTA_POP_UP_STEP_3, ALERT_CREATION_UNKNOWN_SECTION
} from "./constants";

let eventBus: EventBus;

export function init(ev: EventBus = EventBus.getInstance()) {
    eventBus = ev;
}
function initializeRetentionForm(selector: string, email: string | null) {
    if(!email) {
        return;
    }

    eventBus.emit(new dom.PopulateFormEvent({
        selector,
        data: [['email', email]],
    }));
}

function submitRetentionForm(
    formData: FormData,
    emailRetentionSubmitTrackingName: string,
    pageNumber: number,
    isPaid: boolean,
    openedFrom: string,
    isDesktop: boolean,
) {
    trackSubmitEvent(emailRetentionSubmitTrackingName);
    trackSaveSearchAmplitudeEvents(isPaid, pageNumber > 1, openedFrom, isDesktop);
    const search = formData.get("search")?.toString();
    const email = formData.get("email")?.toString();
    const wantNews = formData.get("accept-news") === "on";

    if (search && email) {
        eventBus.emit(new dom.SetContentEvent({selector: "#confirm__search", content: search}));
        eventBus.emit(new dom.SetContentEvent({selector: "#confirm__email__value", content: email}));
        eventBus.emit(new dom.HideEvent({selector: "#form"}));
        eventBus.emit(new dom.ShowEvent({selector: "#email-retention-form__alert-created"}));
        eventBus.emit(new SaveEmailAlertRequestedEvent({ searches: getSearches(search), email, wantNews }));
        eventBus.emit(new FullPageModalCloseEvent({id: "email-retention-modal"}));
    }
}

function getSavedAlertEventSection(
    isPaid: boolean,
    isSuggestion: boolean,
    hasBeenPaginated: boolean,
    retentionFormOpenedFrom: string,
    isDesktop: boolean,
): number {
    if (isDesktop) {
        if (retentionFormOpenedFrom === "desktop-auto-show") {
            return ALERT_CREATION_SECTION_ONPAGE_SEARCH_PAGINATION_POPUP;
        }

        if (isSuggestion) {
            if (retentionFormOpenedFrom === "desktop-floating") return ALERT_CREATION_SECTION_ONPAGE_SEARCH_BOTTOM_STEP_2;
            if (isPaid) return ALERT_CREATION_SECTION_PAID_CTA_POP_UP_STEP_3;
            if (hasBeenPaginated) return ALERT_CREATION_SECTION_ONPAGE_SEARCH_PAGINATION_POPUP_STEP_2;
            return ALERT_CREATION_SECTION_ONPAGE_SEARCH_CTA_POP_UP_STEP_3;
        } else {
            if (retentionFormOpenedFrom === "desktop-floating") return ALERT_CREATION_SECTION_ONPAGE_SEARCH_BOTTOM;
            if (retentionFormOpenedFrom === "detail-traffic-email-retention-form") return ALERT_CREATION_SECTION_ADPAGE_BOX;
            if (retentionFormOpenedFrom === "desktop-top") {
                return isPaid ? ALERT_CREATION_SECTION_PAID_CTA_POP_UP_STEP_2 : ALERT_CREATION_SECTION_ONPAGE_SEARCH_CTA_POP_UP_STEP_2;
            }
        }

        return ALERT_CREATION_UNKNOWN_SECTION;
    } else {
        if (retentionFormOpenedFrom === "email-retention-form--mobile") {
            return isPaid ? ALERT_CREATION_SECTION_ADWORDS_MOBILE_BOTTOM : ALERT_CREATION_SECTION_MOBILE_BOTTOM;
        }

        if (retentionFormOpenedFrom === "detail-traffic-email-retention-form") {
            return ALERT_CREATION_SECTION_ADPAGE_BOX;
        }

        return ALERT_CREATION_UNKNOWN_SECTION;
    }
}

function changeRetentionToggle(eventTarget: HTMLInputElement, emailRetentionToggleTrackingName: string) {
    if (eventTarget && eventTarget.checked) {
        trackToggleAcceptNewsEvent(emailRetentionToggleTrackingName);
    }
}

function trackToggleAcceptNewsEvent(emailRetentionToggleTrackingName: string) {
    eventBus.emit(new tracking.TrackAnalyticsEvent({
        name: emailRetentionToggleTrackingName,
    }));
}

function getSearches(baseSearch: string) {
    let searches = [baseSearch]
    const suggestedChecked: HTMLInputElement[] = getSuggestedSearches();
    suggestedChecked.forEach(input => searches.push(input.value));
    return searches
}

function getSuggestedSearches(): HTMLInputElement[] {
    return dom.selectAllAsType('.email-retention-form__suggestions__inputs__label__input:checked');
}

function trackSubmitEvent(emailRetentionSubmitTrackingName: string) {
    eventBus.emit(
        new tracking.TrackAnalyticsEvent({name: emailRetentionSubmitTrackingName})
    )
}

function trackSaveSearchAmplitudeEvents(
    isPaid: boolean,
    isPagination: boolean,
    retentionFormOpenedFrom: string,
    isDesktop: boolean,
) {
    const numberOfSuggestedSearches = getSuggestedSearches() ? getSuggestedSearches().length : 0;
    for (let i = 0; i < numberOfSuggestedSearches; i++) {
        eventBus.emit(new tracking.TrackAmplitudeEvent({
            section: getSavedAlertEventSection(isPaid, true, isPagination, retentionFormOpenedFrom, isDesktop).toString(),
            type: "SearchSaved",
            serpUrl: window.location.href,
        }))
    }

    eventBus.emit(new tracking.TrackAmplitudeEvent({
        section: getSavedAlertEventSection(isPaid, false, isPagination, retentionFormOpenedFrom, isDesktop).toString(),
        type: "SearchSaved",
        serpUrl: window.location.href,
    }))
}

export default {
    init,
    initializeRetentionForm,
    getSavedAlertEventSection,
    submitRetentionForm,
    changeRetentionToggle,
};
